import type { IconData } from '@stacksjs/iconify-core'

export const shareAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M404 344a75.9 75.9 0 0 0-60.208 29.7l-163.923-93.036a75.7 75.7 0 0 0 0-49.328L343.792 138.3a75.937 75.937 0 1 0-13.776-28.976L163.3 203.946a76 76 0 1 0 0 104.108l166.717 94.623A75.991 75.991 0 1 0 404 344m0-296a44 44 0 1 1-44 44a44.05 44.05 0 0 1 44-44M108 300a44 44 0 1 1 44-44a44.05 44.05 0 0 1-44 44m296 164a44 44 0 1 1 44-44a44.05 44.05 0 0 1-44 44\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default shareAlt
